











































import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";
import { Const } from '@/const'
import { Document } from '@/model/document2/document';
import { Design } from '@/model/document2/page/surface/design/design';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';
import { RasterImageLayer } from '@/model/document2/page/surface/design/layer/rasterImageLayer';
import { VectorImageLayer } from '@/model/document2/page/surface/design/layer/vectorImageLayer';

// Helper
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { UnitHelper } from "@/helper/unitHelper";
import { NativeHelper } from "@/helper/nativeHelper";
import { DebugHelper } from "@/helper/debugHelper";
import { ImageHelper } from "@/helper/imageHelper";
import { MathHelper } from "@/helper/mathHelper"
import { PathHelper } from "@/helper/pathHelper"

import { Rectangle } from '@/utilityModels/rectangle';
import { Vector2 } from '@/utilityModels/vector2';

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class TrimEditor extends Vue 
{
    // 対象レイヤー
    private layer : ImageLayer | null = null;

    // 編集中のトリム情報
    private get trimX() { return this.$store.getters.applicationState.trimSettingX; }
    private set trimX(trimX) { this.$store.getters.applicationState.trimSettingX = trimX; }

    private get trimY() { return this.$store.getters.applicationState.trimSettingY; }
    private set trimY(trimY) { this.$store.getters.applicationState.trimSettingY = trimY; }

    private get trimWidth() { return this.$store.getters.applicationState.trimSettingWidth; }
    private set trimWidth(trimWidth) { this.$store.getters.applicationState.trimSettingWidth = trimWidth; }

    private get trimHeight() { return this.$store.getters.applicationState.trimSettingHeight; }
    private set trimHeight(trimHeight) { this.$store.getters.applicationState.trimSettingHeight = trimHeight; }

    // 編集中のクリップパス
    private clipShapeSvgPath = "";

    // カーソルサイズ
    private cursorWidth = 1;
    private cursorHeight = 1;

    // カーソル
    private selectedCursor = "none";

    // 対象イメージ
    private get image() 
    { 
        var image = "";
        if(this.layer != null)
        {
            image = this.layer.whiteTransparent ? this.layer.imageBase64WhiteTransparent : this.layer.imageBase64;
        }
        return image;
    }
    private get imageWidth()
    {
        var width = 20;
        if(this.layer != null)
        {
            width = this.layer.width;
        }
        return width;
    }
    private get imageHeight()
    {
        var height = 20;
        if(this.layer != null)
        {
            height = this.layer.height;
        }
        return height;
    }

    private getImageSizePixel()
    {
        return {
            width : UnitHelper.convert(this.imageWidth, "mm", "px"),
            height : UnitHelper.convert(this.imageHeight, "mm", "px")
        };
    }

    private getSvgSize()
    {
        return {
            width : UnitHelper.convert(this.imageWidth, "mm", "px") * 4,
            height : UnitHelper.convert(this.imageHeight, "mm", "px") * 4
        };
    }

    private get viewBox()
    {
        return "0 0 " + this.getSvgSize().width + " " + this.getSvgSize().height; 
    }

    private get baseX() { return (this.getSvgSize().width - this.getImageSizePixel().width) / 2; }
    private get baseY() { return (this.getSvgSize().height - this.getImageSizePixel().height) / 2; }
    private get baseWidth() { return this.getImageSizePixel().width; }
    private get baseHeight() { return this.getImageSizePixel().height; }

    // ズーム対象とする
    private leftStyle = "";
    private topStyle = "";
    private widthStyle = "";
    private heightStyle = "";
    private transformStyle = "";
    private get svgWrapperStyle()
    {
        return { 
            left : this.leftStyle, 
            top : this.topStyle, 
            width : this.widthStyle, 
            height : this.heightStyle, 
            transform : this.transformStyle
        };
    }
    // ズームスケール
    private zoomScale = 100;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
    private mounted()
    {
        // モバイルではない場合は、速やかにトップに戻る
        if(!UserAgentHelper.isMobile()) { this.$router.push("/"); }

        // 自動サイズ調整
        this.autoResize();
        this.adjustWindow();

        window.addEventListener('resize', this.onResize);

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        NativeHelper.sendNativeEvent("view_mounted", { view : "TrimEditor" });
    }

    private destroyed()
    {
        window.removeEventListener('resize', this.onResize);

        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");
    }

    private onResize()
    {
        // 自動サイズ調整
        this.autoResize();
        this.adjustWindow();
    }

    // コマンド処理
    private processExecCommand(paramParent : any)
    {
        var command : string = ""; 

        try
        {
            command = paramParent.command;
            var parameter : any = paramParent.parameter;

            if(command == "setup")
            {
                // レイヤーのセット
                var documentJson = parameter.document;
                var pageIndex = Number(parameter.page);
                var isReverse = parameter.isReverse == "true";
                var position = Number(parameter.position);
                var id = parameter.id;

                var doc = Document.createFromJsonData(JSON.parse(documentJson));
                var page = doc.pageList[pageIndex];
                var surface = page.getSurface(isReverse);
                var design = surface.getDesign(position);
                if(design != null)
                {
                    var allLayers = design.getAllLayers(false);
                    for(var i = 0; i < allLayers.length; ++i)
                    {
                        var findLayer = allLayers[i];
                        if(findLayer instanceof ImageLayer && findLayer.id == id)
                        {
                            this.layer = findLayer;
                            this.trimX = findLayer.trimRectNormalized.x;
                            this.trimY = findLayer.trimRectNormalized.y;
                            this.trimWidth = findLayer.trimRectNormalized.width;
                            this.trimHeight = findLayer.trimRectNormalized.height;
                            this.clipShapeSvgPath = this.layer.clipShapeSvgPath;
                            break;
                        }
                    }
                }

                this.$nextTick(() =>
                {
                    // 自動サイズ調整
                    this.autoResize();
                    this.adjustWindow();
                });
            }
            else if(command == "change_clip_type")
            {
                var clipPattern = this.clipTypeToPattern(parameter.type)
                var clipCorner = Number(parameter.corner);

                // 形状
                var clipPath = "";
                if(clipPattern > 0)
                {
                    // サイズ基準は100 x 100, 自動高さ変更は行わない
                    var outHeight = { height : 0 };
                    clipPath = PathHelper.createPattern(clipPattern, clipCorner, 0, 0, 100, 100, 0, 0, 0, false, outHeight);
                }

                this.clipShapeSvgPath = clipPath;
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);

            NativeHelper.sendNativeEvent("error", { command : command } );
        }
    }

    private clipTypeToPattern(type : string)
    {
        var value = 0;
        if(type.toLowerCase() == "circle") { value = 1; }
        else if(type.toLowerCase() == "star") { value = 3; }
        else if(type.toLowerCase() == "arrow") { value = 4; }
        else if(type.toLowerCase() == "polygon") { value = 5; }
        return value;
    }

    private get trimMaskRect()
    {
        var x = this.baseX + this.baseWidth * this.trimX / 100;
        var y = this.baseY + this.baseHeight * this.trimY / 100;
        var w = this.baseWidth * this.trimWidth / 100;
        var h = this.baseHeight * this.trimHeight / 100;
        return new Rectangle(x, y, w, h);
    }

    private get x1() : number { return this.trimMaskRect.x; }
    private get y1() : number { return this.trimMaskRect.y; }
    private get x2() : number { return this.trimMaskRect.x; }
    private get y2() : number { return this.trimMaskRect.bottom; }
    private get x3() : number { return this.trimMaskRect.right; }
    private get y3() : number { return this.trimMaskRect.bottom; }
    private get x4() : number { return this.trimMaskRect.right; }
    private get y4() : number { return this.trimMaskRect.y; }

    private get clipPath()
    {
        return this.clipShapeSvgPath;
    }

    private get clipPathTransform()
    {
        var transform = "";

        // 移動
        transform += "translate(" + this.trimMaskRect.x + " " + this.trimMaskRect.y + "),";

        // 100 -> 領域に拡大する
        var scaleX = this.trimMaskRect.width / 100;
        var scaleY = this.trimMaskRect.height / 100;
        transform += "scale(" + scaleX + " " + scaleY + ")";
        
        return transform;
    }

    private get baseTransform()
    {
        if(this.layer == null) { return ""; }

        var transform = "";

        transform += "translate(" + this.baseX + " " + this.baseY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        transform += "translate(" + (-this.baseX) + " " + (-this.baseY) + ")";
        
        return transform;
    }


    // 自動でほどよいサイズにリサイズ
    private autoResize()
    {
        var wScale = (window.innerWidth * 0.8) / this.getImageSizePixel().width;
        var hScale = (window.innerHeight * 0.8) / this.getImageSizePixel().height;
        var zoomScale = Math.min(wScale, hScale) * 100;

        this.zoomScale = zoomScale;

        // カーソルサイズ
        var cursorSizeMm = 22 * 4 * this.imageWidth * 100 / (this.getSvgSize().width * zoomScale);
        var cursorSize = UnitHelper.convert(cursorSizeMm, "mm", "px");
        this.cursorWidth = cursorSize;
        this.cursorHeight = cursorSize;
    }

    // ウィンドウの表示調整
    private adjustWindow()
    {
        this.leftStyle = "calc(50% - " + (this.getSvgSize().width * this.zoomScale / 100 / 2) + "px)";
        this.topStyle = "calc(50% - " + (this.getSvgSize().height * this.zoomScale / 100 / 2) + "px)";
        this.widthStyle = this.getSvgSize().width * this.zoomScale / 100 + "px";
        this.heightStyle = this.getSvgSize().height * this.zoomScale / 100 + "px";
        this.transformStyle = "translate(0,0)";
    }

    // カーソル選択イベント
    private selectCursor(event, cursor : string)
    {
        this.selectedCursor = cursor;
    }

    // タッチ
    private srcTouchX = 0;
    private srcTouchY = 0;
    private srcTrimX = 0;
    private srcTrimY = 0;
    private srcTrimWidth = 0;
    private srcTrimHeight = 0;
    private isMoving = false;
    private onTouchStart(event : TouchEvent)
    {
    }

    private onTouchMove(event : TouchEvent)
    {
        var touches = event.touches;
        if(touches.length == 1 && this.selectedCursor != "none" && this.layer != null)
        {
            var touchX = touches[0].clientX;
            var touchY = touches[0].clientY;
            if(this.isMoving)
            {
                // 移動差分
                var currentPos = this.clientToMm(touchX, touchY);
                var srcPos = this.clientToMm(this.srcTouchX, this.srcTouchY);
                var deltaX = currentPos.x - srcPos.x;
                var deltaY = currentPos.y - srcPos.y;

                // 差分ベクトルを分解する
                var deltaVector = new Vector2(deltaX, deltaY);
                var deltaResolution = deltaVector.getResolutionDegrees(this.layer.rotate);

                var dstTrimX = this.srcTrimX;
                var dstTrimY = this.srcTrimY;
                var dstTrimWidth = this.srcTrimWidth;
                var dstTrimHeight = this.srcTrimHeight;

                if(this.selectedCursor == "top_left")
                {
                    // 左上を移動 == 右下固定
                    dstTrimX = this.srcTrimX + deltaResolution.x / this.imageWidth * 100;
                    dstTrimY = this.srcTrimY + deltaResolution.y / this.imageHeight * 100;
                    dstTrimWidth = this.srcTrimWidth - deltaResolution.x / this.imageWidth * 100;
                    dstTrimHeight = this.srcTrimHeight - deltaResolution.y / this.imageHeight * 100;
                }
                else if(this.selectedCursor == "bottom_left")
                {
                    // 左下を移動 == 右上固定
                    dstTrimX = this.srcTrimX + deltaResolution.x / this.imageWidth * 100;
                    dstTrimWidth = this.srcTrimWidth - deltaResolution.x / this.imageWidth * 100;
                    dstTrimHeight = this.srcTrimHeight + deltaResolution.y / this.imageHeight * 100;
                }
                else if(this.selectedCursor == "bottom_right")
                {
                    // 右下を移動 == 左上固定
                    dstTrimWidth = this.srcTrimWidth + deltaResolution.x / this.imageWidth * 100;
                    dstTrimHeight = this.srcTrimHeight + deltaResolution.y / this.imageHeight * 100;
                }
                else if(this.selectedCursor == "top_right")
                {
                    // 右上を移動 == 左下固定
                    dstTrimY = this.srcTrimY + deltaResolution.y / this.imageHeight * 100;
                    dstTrimWidth = this.srcTrimWidth + deltaResolution.x / this.imageWidth * 100;
                    dstTrimHeight = this.srcTrimHeight - deltaResolution.y / this.imageHeight * 100
                }

                // 値補正
                if(dstTrimWidth < 0)
                {
                    dstTrimWidth *= -1;
                    dstTrimX -= dstTrimWidth;
                }
                if(dstTrimHeight < 0)
                {
                    dstTrimHeight *= -1;
                    dstTrimY -= dstTrimHeight;
                }
                if(dstTrimX < 0)
                {
                    dstTrimWidth += dstTrimX;
                    dstTrimX = 0;
                }
                if(dstTrimX + dstTrimWidth > 100)
                {
                    dstTrimWidth -= dstTrimX + dstTrimWidth - 100;
                    dstTrimWidth = 100 - dstTrimX;
                }
                if(dstTrimY < 0)
                {
                    dstTrimHeight += dstTrimY;
                    dstTrimY = 0;
                }
                if(dstTrimY + dstTrimHeight > 100)
                {
                    dstTrimHeight -= dstTrimY + dstTrimHeight - 100;
                    dstTrimHeight = 100 - dstTrimY;
                }

                // トリミング
                this.trimX = dstTrimX;
                this.trimY = dstTrimY;
                this.trimWidth = dstTrimWidth;
                this.trimHeight = dstTrimHeight;
            }
            else
            {
                // 初期値保持
                this.srcTouchX = touchX;
                this.srcTouchY = touchY;
                this.srcTrimX = this.trimX;
                this.srcTrimY = this.trimY;
                this.srcTrimWidth = this.trimWidth;
                this.srcTrimHeight = this.trimHeight;
                this.isMoving = true;
            }            
        }

        // デフォルトの動作をオフ
        event.preventDefault();
    }

    private onTouchEnd(event : TouchEvent)
    {
        this.selectedCursor = "none";
        this.isMoving = false;
    }

    // 画面上のクライアント座標 -> mm座標
    private clientToMm(x, y)
    {
        // クライアント座標 -> SVG座標
        var svg = this.$refs.svg as SVGSVGElement;
        var point = svg.createSVGPoint();
        point.x = x;
        point.y = y;
        var m = svg.getScreenCTM();
        if(m == null) { return new Vector2(0, 0); }
        var p = point.matrixTransform(m.inverse());
        
        // SVG座標 -> mm座標
        return new Vector2(UnitHelper.convert(p.x, "px", "mm"), UnitHelper.convert(p.y, "px", "mm"));
    }
}
